export default "__VITE_ASSET__BafTg9cn__"